export default __webpack_public_path__ + "static/media/andry.35f88ee4.PNG";